export type TStateWithLoading<T = Record<any, any>> = {
  data: T | null
  loading: boolean
  error: string | null
}

export enum ROIModuleState {
  Show = 'Show', // Display the ROI Module
  Hidden = 'Hidden', // Hide the ROI Module
  SiteSpecific = 'SiteSpecific', // Display disclaimer mentioning we don't have data
}

export interface OptimalRoiMetricsData {
  averageOrderFrequencyLift: number | null
  averageOrderValueLift: number | null
  beamAOV: number | null
  beamAOVSalesLift: number | null
  beamCCR: number | null
  beamFees: number | null
  beamOrderFrequency: number | null
  beamOrderFrequencySalesLift: number | null
  beamROI: number | null
  blendedROI: number | null
  ccrLift: number | null
  ccrSalesLift: number | null
  customersUsingBeam: number | null
  donations: number | null
  isEstimatedCCRIncluded: boolean
  nonBeamCCR: number | null
  nonBeamOrderFrequency: number | null
  nonbeamAOV: number | null
  pctCcrLift: number | null
  redemptionRate: number | null
  reportPeriodId: string | null
  roiPeriodDate: string | null
  salesLift: number | null
  shouldDisplayRoiModule: boolean // TODO: Deprecate after `roiModuleState` is deployed to production
  roiModuleState: ROIModuleState.Show
  totalCCR: number | null
  totalFees: number | null
}
export type RoiMetricsResponsePayload = { optimalMetrics: OptimalRoiMetricsData }
export type BusinessImpactStateWithLoading = TStateWithLoading<RoiMetricsResponsePayload>

export interface NonprofitType {
  name: string
  cause: string
  cause_icon: string
  image: string | null
  website: string
  impact_description: string
  impact: Impact
  target_image: string | null
  thin_target_image: string | null
  chain_target_image: string | null
  regions: string[]
  id: number
  active: boolean
  isTrending?: boolean | null
  storeNonprofit?: number
}

export interface Impact {
  chain_donated: number
  match_donated: number
  total_donated: number
  target_donation_amount: number
}
